import { render, staticRenderFns } from "./CreateComplaint.vue?vue&type=template&id=7e1c7e52&"
import script from "./CreateComplaint.vue?vue&type=script&lang=js&"
export * from "./CreateComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports